<template>
  <div>
    <v-layout
      row
      align-center
      :style="myLayoutStyle"
    >
      <v-flex
        xs12
        sm10
        offset-sm1
        md10
        offset-md1
        lg10
        offset-lg1
        xl8
        offset-xl2
      >
        <v-card
          v-if="cartQty > 0"
          flat
          :color="theme.bg_color"
        >
          <v-card-text>
            <v-layout>
            <page-title :title="$t('cart')" />
              <v-spacer></v-spacer>
              <v-btn
                v-if="isMember && showCustomSet"
                icon
                @click="customSetNameDialog = true"
              >

              </v-btn>
            </v-layout>
            <div
              v-if="mode.isTakeaway || mode.isDelivery"
              class="mt-1 mb-2"
            >
              <delivery-progress-bar v-if="mode.isDelivery && cartQty > 0 && this.deliveryConfig.discountData.length > 0"></delivery-progress-bar>
              <takeaway-timer />
            </div>
            <div
              v-if="mode.isDelivery"
              class="mt-1 mb-2"
            >
              <address-selector />
              <delivery-remarks />
            </div>
            <div>
              <h3 v-if="mode.isTakeaway || mode.isDelivery" :style="titleStyle">{{ $t('items') }}</h3>
              <div v-for="(cat, category_name) in groupItemByCat" :key="category_name">
                <span
                  class="name"
                  :style="myNameStyle"
                >{{ category_name }}</span>
                <div
                  v-for="item in cat"
                  :key="item.cart_id"
                >
                  <cart-item :item="item" />
                </div>
              </div>
            </div>
            <v-card
              v-if="mode.isDelivery && deliveryConfig.enableCutlery"
            >
              <h5
                class="pt-2 pl-3 pb-0"
                style="color: #228b22;"
              ><span style="font-weight: bolder">{{ cutleryTitle }}</span>
              </h5>
              <v-layout
                row
              >
                <v-flex xs10 class="pr-2">
                  <h5
                    class="pt-0 pl-3 pb-2"
                  >
                    <span style="font-weight: bolder">{{ cutleryLabel }}</span>
                  </h5>
                </v-flex>
                <v-flex xs2>
                  <v-switch
                    class="pa-0 ma-0"
                    v-model="cutlery"
                    hide-details
                    color="red"
                    inset
                    @change="updateCutlery"
                  >
                  </v-switch>
                </v-flex>
              </v-layout>
            </v-card>
            <div
              v-if="config.payment_charges_info"
              class="mt-2"
            >
              <v-card
                shaped
                :color="theme.address_bg_color"
                :style="infoStyle"
              >
                <v-card-text>
                  <v-layout
                    row
                    justify-center
                    align-center
                  >
                    <v-flex xs1>
                      <v-icon
                        small
                        :color="theme.address_text_color"
                      >fas fa-info-circle</v-icon>
                    </v-flex>
                    <v-flex
                      xs11
                      class="ml-1"
                    >
                      <span :style="infoTextStyle">{{ config.payment_charges_info }}</span>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </div>
            <cart-item-dialog v-if="cartItemDialog" />
          </v-card-text>
        </v-card>
        <v-card
          v-else
          flat
          :color="theme.bg_color"
        >
          <v-card-text>
            <page-title :title="$t('cart')" />
            <div>
              <h3 :style="nameStyle">{{ $t('basket_empty') }}</h3>
            </div>
            <div :style="addItemStyle">
              <v-btn
                :color="theme.btn_color_secondary"
                flat
                @click="addItems"
              >{{ $t('add_item') }}</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <promo-items-dialog v-if="showPromoItemsDialog" />
    <v-dialog
      v-model="customSetNameDialog"
      persistent
    >
      <v-card :color="theme.login_bg_color">
        <v-card-text class="pa-4">
          <v-layout row>
            <v-flex
              xs12
              sm10
              offset-sm1
              md8
              offset-md2
              lg6
              offset-lg3
              xl6
              offset-xl3
            >
              <v-layout
                row
                align-center
              >
                <v-flex xs12>
                  <span class="main-title">{{ $t('add_custom_set') }}</span>
                </v-flex>
              </v-layout>
              <div class="mt-2">
                <v-text-field
                  v-model="customSetName"
                  :color="theme.btn_color_secondary"
                  outline
                  label="Name"
                  v-validate="'required|max:25'"
                ></v-text-field>
              </div>
              <div class="mt-3 text-xs-center">
                <v-btn
                  dark
                  :color="theme.btn_color_secondary"
                  @click="addToCustomSet"
                >
                  {{ $t('save') }}
                </v-btn>
                <v-btn
                  flat
                  :color="theme.btn_color_secondary"
                  @click="customSetNameDialog = false"
                >
                  {{ $t('close') }}
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import CartItem from '~/components/CartItem'
import CartItemDialog from '~/components/CartItemDialog'
import TakeawayTimer from '~/components/TakeawayTimer'
import AddressSelector from '~/components/AddressSelector'
import PromoItemsDialog from '~/components/PromoItemsDialog'
import DeliveryProgressBar from '../components/DeliveryProgressBar'
import DeliveryRemarks from '../components/DeliveryRemarks'

export default {
  name: 'cart-view',
  metaInfo () {
    return { title: this.$t('cart') }
  },
  data () {
    return {
      cutlery: false,
      customSetName: '',
      customSetNameDialog: false
    }
  },
  components: {
    'page-title': PageTitle,
    'cart-item': CartItem,
    'cart-item-dialog': CartItemDialog,
    'takeaway-timer': TakeawayTimer,
    'address-selector': AddressSelector,
    'promo-items-dialog': PromoItemsDialog,
    'delivery-progress-bar': DeliveryProgressBar,
    'delivery-remarks': DeliveryRemarks,
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'rid', 'gid', 'config', 'mode', 'language', 'deliveryConfig'
    ]),
    ...mapGetters('cart', [
      'cart', 'cartItemDialog', 'cartAmount', 'cartQty', 'pickupTime'
    ]),
    ...mapGetters('delivery', [
      'address'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    cutleryTitle () {
      if (this.language === 'zh-SG') {
        return "支持環保，拒絕一次性塑料餐具！"
      }
      return "Go green and say no to single-use plastic!"
    },
    cutleryLabel () {
      if (this.language === 'zh-SG') {
        return this.cutlery || this.address.cutlery ? "我需要餐具。" : "我不需要餐具。"
      }
      return this.cutlery || this.address.cutlery ? "I need cutlery." : "I do not need cutlery."
    },
    // cutlerySubLabel () {
    //   if (this.language !== 'zh-SG') {
    //     // return this.cutlery || this.address.cutlery ? "下次環保吧！" : "为環保贡献。"
    //     return this.cutlery || this.address.cutlery ? "I'll go green next time!" : "Happy to do my part for Earth."
    //   }
    //   return ''
    // },
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    titleStyle () {
      return {
        color: this.theme.orders_title_color
      }
    },
    nameStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    addItemStyle () {
      return {
        textAlign: 'right',
        marginTop: '20px',
        color: this.theme.orders_name_color
      }
    },
    paymentChargesStyle () {
      return {
        fontSize: '14px',
        marginTop: '15px',
        color: this.theme.cart_remarks_color
      }
    },
    myNameStyle () {
      return {
        color: this.theme.cart_name_color
      }
    },
    infoStyle () {
      return {
        marginTop: '15px',
        border: `1px solid ${this.theme.address_text_color}`
      }
    },
    infoTextStyle () {
      return {
        color: this.theme.address_text_color,
        fontSize: '14px',
        whiteSpace: 'pre-wrap',
      }
    },
    groupItemByCat () {
      if (this.language !== 'en-SG') {
        return _.groupBy(this.cart, (item) => {
          return item.category_alternate_name ? item.category_alternate_name : item.category_name
        })
      }
      return _.groupBy(this.cart, 'category_name')
    },
    showCustomSet () {
      return (parseInt(this.config.group_id) !== 533)
    },
    showPromoItemsDialog () {
      return !this.$store.getters['message/isShowResponseMessage'];
    }
  },
  methods: {
    addItems () {
      this.$router.push({ name: 'menu', params: { gid: this.gid, rid: parseInt(this.rid) }})
    },
    updateCutlery () {
      this.$store.dispatch('delivery/setAddressCutlery', this.cutlery)
    },
    async addToCustomSet () {
      await this.$store.dispatch('auth/addCustomSet', {
        name: this.customSetName,
        items: JSON.stringify(this.cart)
      })
      this.customSetNameDialog = false
      this.$store.dispatch('responseMessage', {
        type: 'success',
        text: this.$t('custom_set_saved_success_notice')
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    // When browser / phone's back button is clicked, it should go back to menu
    if (this.cartItemDialog) {
      this.$store.dispatch('cart/hideCartItemDialog')
      next(false)
    } else {
      next()
    }
  },
  beforeMount () {
    if (this.isMember) this.$store.dispatch('fetchMembershipInfo')
    this.cutlery = this.address.cutlery
    const x = this.cart.findIndex(i => {
      return i.is_auto_preset === true
    })
    if (x !== -1) {
      this.cart.pop(x)
    }
  },
  mounted () {
    this.$bus.$emit('showPromoItemsDialog', true)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/cart.vue